module.exports = __webpack_public_path__ + "img/57749b2.png";